import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import Page from '~/components/page/page';
import TitleBar from '~/components/titleBar/titleBar';
import VesselType from '~/containers/vesselType/vesselType';

export class VesselTypePage extends Component {
  state = {
    vesselType: null
  };

  onReceiveCode = ({ vesselType }) => {
    this.setState({
      vesselType
    });
  };

  render() {
    const vesselTypeId = this.props.match.params.vesselTypeId;
    const { vesselType } = this.state;

    const editButton = (
      <Link to={`/settings/vesselTypes/${vesselTypeId}/edit`}>
        <Button data-qa="vesselType-edit" color="primary">
          Edit
        </Button>
      </Link>
    );

    return (
      <Page>
        <TitleBar
          back="/settings/vesseltypes"
          backText="Vessel types"
          title={vesselType ? vesselType.name : '...'}
          button={editButton}
        />
        <VesselType onCompleted={this.onReceiveCode} id={vesselTypeId} />
      </Page>
    );
  }
}

export default connect(state => ({
  brewery: state.brewery
}))(withRouter(VesselTypePage));



// WEBPACK FOOTER //
// ./src/pages/vesselType/vesselType.jsx